import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";

export interface iFinalRankFilterLoadState {
    response: any;
    isLoading: boolean;
    message: string | null;
    backupList: any[];
}

const initialState: iFinalRankFilterLoadState = {
    response: null,
    isLoading: false,
    message: "",
    backupList: [],
};

// workFlowFinalRankFilterLoadAPI 수정
export const workFlowFinalRankFilterLoadAPI = createAsyncThunk(
    "workFlowFinalRankFilterLoadAPI",
    async (data: {
        workflow_name: string;
        group_name: string;
        library_name: string;
        round: number;
    }, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = `/workflow/final-rank-filter-load/?workflow_name=${data.workflow_name}&group_name=${data.group_name}&library_name=${data.library_name}&round=${data.round}`;
            const response = await axiosInstance.get(`${djangoEndpoint}${pathParam} `, {
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const workflowRankFilterLoadSlice = createSlice({
    name: "workflowRankFilterLoad",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(workFlowFinalRankFilterLoadAPI.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(workFlowFinalRankFilterLoadAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload;
                state.backupList = action.payload.backup_list;
            })
            .addCase(workFlowFinalRankFilterLoadAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.message = action.payload as string;
            });
    },
});


export default workflowRankFilterLoadSlice.reducer;